import React, { useState, useEffect } from 'react'
import { autorun } from 'mobx'
import { matchPath, useNavigate, useLocation } from 'react-router-dom'
import { mainStore } from 'enasops/stores'
import { FormPage } from 'src/components'
import { $consts } from 'src/plugins'
import { getFirstValidTree } from 'enasops/utils/tools'

const FakePage = () => {
  return null
}

const Main = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [formState, setFormState] = useState({ formCode: '', formKey: '' })

  useEffect(() => autorun(() => {
    const matchMenu = matchPath({
      path: $consts['ROUTE/MAIN'],
    }, location.pathname)
    if (mainStore.flatMenus.length) {
      const find = mainStore.flatMenus.find((item: any) => item.ID === matchMenu?.params?.menuId)
      if (find) {
        const formCode = find.Nav_MenuForm?.CODE
        setFormState({ formCode, formKey: `${formCode}_${find.MENU_FORM_PARAMS}` })
        mainStore.setActiveMenu(find)
      } else {
        navigate(`/main/${getFirstValidTree(mainStore.menus[0])}`)
      }
    }
  }), [location.pathname])

  if (!formState.formCode) {
    return <FakePage />
  }

  return (
    <React.Fragment>
      <FormPage key={formState.formKey} formCode={formState.formCode} />
    </React.Fragment>
  )
}

export default Main